/**
 * CRA: `REACT_APP_API_URL` 기본 `http://localhost:5000/api`
 * 런타임에 개행·앞뒤 공백이 섞여도 요청이 깨지지 않도록 정규화합니다(빌드 전 `scripts/checkReactEnv.js` 와 병행).
 */
const DEFAULT_API_BASE = 'http://localhost:5000/api';

/**
 * @param {string|undefined|null} raw
 * @returns {string}
 */
export function normalizeReactAppApiUrl(raw) {
  if (raw == null) return DEFAULT_API_BASE;
  let s = String(raw).replace(/\r\n|\r|\n/g, '').trim();
  if (!s) return DEFAULT_API_BASE;
  s = s.replace(/\/+$/, '');
  return s;
}

function resolvedBase() {
  return normalizeReactAppApiUrl(process.env.REACT_APP_API_URL);
}

/** `/transfer/...` 등에 붙이는 API 베이스 (`.../api`) */
export function getApiBaseUrl() {
  return resolvedBase();
}

/**
 * @returns {string} `/api` 접미사 제거한 origin (예: http://localhost:5000)
 */
export function getApiOrigin() {
  const base = resolvedBase();
  return base.replace(/\/?api\/?$/i, '');
}

/**
 * @param {string} claimPublicToken
 */
export function getPublicReceiptJsonUrl(claimPublicToken) {
  const base = resolvedBase();
  return `${base.replace(/\/$/, '')}/transfer/public/${claimPublicToken}/receipt`;
}

/**
 * @param {string} claimPublicToken
 */
export function getPublicReceiptHtmlUrl(claimPublicToken) {
  const base = resolvedBase();
  return `${base.replace(/\/$/, '')}/transfer/public/${claimPublicToken}/receipt.html`;
}
